'use strict';

const config = {
    editSelector: '.edit-translation',
    saveSelector: '.translation-save-button',
    rowSelector: '.translation-key-value',
    valueSelector: '.translation-value',
    editValueSelector: '.js-edit-translation-value',
    editKeySelector: '.js-edit-translation-key',
    nameAttrSelector: '[name="translation-value"]',
    notAllowedClass: 'not-allowed',
    hideClass: 'u-hide'
};

$(document).ready(function () {
    const editTranslation = $(config.editSelector);

    editTranslation.removeClass(config.notAllowedClass);
    editTranslation.on('click', function (e) {
        e.preventDefault();
        resetEdit();

        $(this).parent().find(config.saveSelector).removeClass(config.hideClass);

        const translationValueDiv = $(this).closest(config.rowSelector).find(config.valueSelector);
        const translationTextarea = $(this).closest(config.rowSelector).find(config.editValueSelector);

        translationTextarea.attr('name', 'translation-value');
        translationTextarea.removeClass(config.hideClass);

        translationValueDiv.html('');
        translationValueDiv.append(translationTextarea);

        const translationKey = $(this).parent().find(config.editKeySelector);
        translationKey.attr('name', 'translation-key');

        $(this).addClass(config.hideClass);
    });

    function resetEdit() {
        const originalTranslationTextarea = $(config.nameAttrSelector);
        const originalTranslation = originalTranslationTextarea.data('original-translation');

        $(config.editSelector).removeClass(config.hideClass);
        $(config.saveSelector).addClass(config.hideClass);

        originalTranslationTextarea.addClass(config.hideClass);
        originalTranslationTextarea.attr('name', '');

        originalTranslationTextarea.val(originalTranslation);
        originalTranslationTextarea.parent().append(originalTranslation);

        $(config.editKeySelector).attr('name', '');
    }
});



// WEBPACK FOOTER //
// ./src/js/components/translation-editor.js